import { LOCAL_STORAGE_KEYS, FEATURE_TYPES } from 'constants'
import { isFeatureAvailable } from './accounts'

export const defaultVehiclesFilter = {
    nation: 'all_nations',
    vehicleTypes: [],
    onlyFavorite: false,
    sortColumn: 'nation',
    sortOrder: undefined,
}

const { ALL_VEHICLES, BATTLE_ROOMS_VEHICLE_LEVEL, SELECTED_VEHICLES, VEHICLES_FILTER } = LOCAL_STORAGE_KEYS

export const getParsedStorageItem = key => {
    const storageItem = localStorage.getItem(key)
    if (storageItem === 'undefined') return null
    try {
        return JSON.parse(storageItem)
    } catch (e) {
        localStorage.removeItem(key)
        return null
    }
}

export const saveToStorage = (key, value) => {
    localStorage.setItem(key, JSON.stringify(value))
}

export const saveSelectedVehicleCds = (vehicleLevel, vehicleCds) => {
    saveToStorage(SELECTED_VEHICLES + vehicleLevel, vehicleCds)
}

export const saveAllVehicleCds = vehicleCds => saveToStorage(ALL_VEHICLES, vehicleCds)

export const restoreAllVehicleCds = () => getParsedStorageItem(ALL_VEHICLES)

export const saveFilter = (vehicleLevel, filter) => {
    saveToStorage(VEHICLES_FILTER + vehicleLevel, filter)
}

export const saveBattleRoomsVehicleLevel = vehicleLevel => {
    saveToStorage(BATTLE_ROOMS_VEHICLE_LEVEL, vehicleLevel)
}

export const restoreVehicleFilter = vehicleLevel => {
    const parsed_vehicle_filter = getParsedStorageItem(
        VEHICLES_FILTER + vehicleLevel,
    )
    return parsed_vehicle_filter ? parsed_vehicle_filter : defaultVehiclesFilter
}

export const restoreVehicleCds = vehicleLevel => getParsedStorageItem(SELECTED_VEHICLES + vehicleLevel)

export const clearSelectedVehicleCds = vehicle_level => (
    localStorage.removeItem(SELECTED_VEHICLES + vehicle_level)
)

export const restoreVehicleCdsByLevel = (vehicles, vehicleLevel) => (
    vehicles
        .filter(vehicle => vehicle.level === vehicleLevel)
        .map(vehicle => vehicle.id)
)

export const isBattleModeEnabled = (sortieSettings) => {
    return sortieSettings.some((setting) => setting.enabled || setting.show_challenges_message)
}

export const isPlayersMatchingAvailable = (account, playersMatching) => {
    return isFeatureAvailable(account, FEATURE_TYPES.PLAYERS_MATCHING) &&
        isBattleModeEnabled(playersMatching.sortie_settings)
}



// WEBPACK FOOTER //
// ./helpers/playersMatching.js